import { addDays, isDate, isValid } from 'date-fns';
import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

function toJoinUsDate(value: unknown) {
  let date: Date | null =
    typeof value === 'string' && value !== ''
      ? new Date(value.replaceAll('"', ''))
      : typeof value === 'number'
        ? new Date(value)
        : value instanceof Date
          ? value
          : null;
  if (!date || !isDate(date) || !isValid(date) || date <= new Date('2025-09-29')) {
    // If the date is before Sept 30th, 2025, we should show the modal.
    date = null;
  }
  return date;
}

export function getJoinUsLocalStorage() {
  let data = window.localStorage.getItem('joinUsModal');
  if (typeof data === 'string') {
    data = toJoinUsDate(data)?.toISOString() ?? '';
  }
  return '';
}

export function useJoinUsLocalStorage() {
  const [dateString, setDate] = useLocalStorage<string>('joinUsModal', () => getJoinUsLocalStorage());
  const setJoinUsDate = useCallback(
    (daysFromNow: number | null) => {
      if (daysFromNow === null) {
        setDate('');
      } else {
        setDate(addDays(new Date(), daysFromNow).toISOString());
      }
    },
    [setDate],
  );
  const date = toJoinUsDate(dateString);

  return { date, setJoinUsDate };
}
